import "./CreateStoreModal.css";
import PopUp from "../../components/PopUp";
import { CreateStoreForm } from "./createStoreForm";

export default function CreateStoreModal(props) {
  return (
    <div className="create-store-container">
      <PopUp handleSubmit={props.togglePopUp} title={props.title}>
        <CreateStoreForm {...props} />
      </PopUp>
    </div>
  );
}
